'use client'

import UIFlex from '@components/ui/UIFlex'
import UIText from '@components/ui/UIText'
import { Box, Radio, RadioGroup } from '@mui/joy'
import color from '@ui/style/color.theme'
import { pxToRem } from '@ui/style/muiTheme'
import { PollSetProps } from './types'
import UIImage from '@components/ui/UIImage'

const PollYesNoSet = ({ poll, auth, selected, setSelected, authAction }: PollSetProps) => {
	const targetCode = poll.participationTargetCode?.code
	const handleSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (targetCode === 'MEMBER-ONLY' && !auth) {
			authAction()
		} else if ((targetCode === 'MEMBER-ONLY' && auth) || targetCode === 'ALL') {
			setSelected([e.target?.value as string])
		}
	}
	return (
		<RadioGroup name="poll-yesNo-group">
			<UIFlex
				flexDirection="row"
				sx={{
					'&>*:not(:first-child)': {
						marginLeft: pxToRem(16),
					},
				}}
			>
				{poll.answerList?.map((answer) => {
					return (
						<UIFlex width="50%" alignSelf="stretch" key={`answer-${answer.answerIdx}`}>
							<Radio
								value={answer.answerIdx}
								label={
									answer.answerImgUrl ? (
										<UIFlex>
											<Box width="100%">
												<UIImage
													ratio="16/9"
													src={answer.answerImgUrl}
													alt=""
												/>
											</Box>
											<UIText
												fontSize={pxToRem(14)}
												lineHeight={pxToRem(20)}
												fontWeight={600}
												padding={`${pxToRem(8)} ${pxToRem(14)}`}
											>
												{answer.answerContent}
											</UIText>
										</UIFlex>
									) : (
										<UIText
											fontSize={pxToRem(14)}
											lineHeight={pxToRem(20)}
											fontWeight={600}
											textAlign="center"
											padding={pxToRem(24)}
										>
											{answer.answerContent}
										</UIText>
									)
								}
								disableIcon
								slotProps={{
									action: {
										sx: {
											top: 0,
											left: 0,
											right: 0,
											bottom: 0,
											border: 0,
											opacity: 0,
										},
									},
									label: ({ checked }) => ({
										sx: {
											display: 'flex',
											width: '100%',
											borderRadius: pxToRem(8),
											border: `1px solid ${
												checked ? color.colPointBlue : 'transparent'
											}`,
											background: checked
												? color.colLightBlue
												: color.colWhite,
											overflow: 'hidden',
											flexGrow: 1,
											alignItems: answer.answerImgUrl
												? 'flex-start'
												: 'center',
											justifyContent: 'center',
											color: color.colBlack,
											'&>div': {
												width: '100%',
											},
										},
									}),
								}}
								sx={{ height: '100%' }}
								checked={selected.includes(answer.answerIdx.toString())}
								onChange={handleSelect}
							/>
						</UIFlex>
					)
				})}
			</UIFlex>
		</RadioGroup>
	)
}

export default PollYesNoSet
